import { NavigateFunction } from 'react-router-dom';
import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { childrenAttendTrackPageBreadcrumbs } from '@/pages/AttendTrack/config/breadcrumbs';

export const dashboardPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenAttendTrackPageBreadcrumbs(navigate),
  { label: 'Dashboard', onClick: () => navigate('/attend-track/dashboard') },
];
